import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["primary", "dependent"]

  primaryChanged() {
    if (!this.primaryTarget.checked) this.dependentTarget.checked = false
  }

  dependentChanged() {
    if (this.dependentTarget.checked) this.primaryTarget.checked = true
  }
}
